package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.PersonW500RoundedFill: ImageVector
    get() {
        if (_personW500RoundedFill != null) {
            return _personW500RoundedFill!!
        }
        _personW500RoundedFill = Builder(name = "PersonW500RoundedFill", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(361.14f, 426.66f)
                quadToRelative(-49.27f, -49.27f, -49.27f, -118.86f)
                quadToRelative(0.0f, -69.58f, 49.27f, -118.74f)
                quadToRelative(49.27f, -49.15f, 118.86f, -49.15f)
                reflectiveQuadToRelative(118.86f, 49.15f)
                quadToRelative(49.27f, 49.16f, 49.27f, 118.74f)
                quadToRelative(0.0f, 69.59f, -49.27f, 118.86f)
                quadToRelative(-49.27f, 49.27f, -118.86f, 49.27f)
                reflectiveQuadToRelative(-118.86f, -49.27f)
                close()
                moveTo(151.87f, 721.2f)
                verticalLineToRelative(-29.61f)
                quadToRelative(0.0f, -36.16f, 18.7f, -66.57f)
                quadToRelative(18.69f, -30.41f, 49.84f, -46.37f)
                quadToRelative(62.72f, -31.24f, 127.68f, -46.98f)
                quadToRelative(64.95f, -15.74f, 131.91f, -15.74f)
                quadToRelative(67.43f, 0.0f, 132.39f, 15.62f)
                quadToRelative(64.96f, 15.62f, 127.2f, 46.86f)
                quadToRelative(31.15f, 15.96f, 49.84f, 46.25f)
                quadToRelative(18.7f, 30.3f, 18.7f, 66.93f)
                verticalLineToRelative(29.61f)
                quadToRelative(0.0f, 37.78f, -26.61f, 64.39f)
                reflectiveQuadToRelative(-64.39f, 26.61f)
                lineTo(242.87f, 812.2f)
                quadToRelative(-37.78f, 0.0f, -64.39f, -26.61f)
                reflectiveQuadToRelative(-26.61f, -64.39f)
                close()
            }
        }
        .build()
        return _personW500RoundedFill!!
    }

private var _personW500RoundedFill: ImageVector? = null
